import { TemplateResult, html } from "lit-html";
import classNames from "classnames";
import { HauntedFunc } from "Shared/haunted/HooksHelpers";
import { unsafeHTML } from "lit-html/directives/unsafe-html";

export const useShadowDOM = false;
export const name = "dc-accordion";

export interface Props {
	headerClass?: string;
	headerIconClass?: string;
	headerTitle: string | TemplateResult;
	hideBorder?: boolean;
	isOpen: boolean;
	contentTemplate?: () => TemplateResult;
	onClick: () => void;
}

export const Component: HauntedFunc<Props> = (host) => {
	const props: Props = {
		headerClass: host.headerClass ? host.headerClass : "",
		headerIconClass: host.headerIconClass ? host.headerIconClass : "",
		headerTitle: host.headerTitle,
		isOpen: host.isOpen,
		contentTemplate: host.contentTemplate ? host.contentTemplate : () => html``,
		onClick: host.onClick,
	};

	const accordionTriangleIconTemplate = () => html`
		<div
			class=${classNames(
				"border-x-[5px] border-b-0 border-t-[5px] border-solid border-x-transparent common-transition origin-[50%_50%]",
				{
					"-rotate-180": props.isOpen,
					"rotate-0": !props.isOpen,
					"border-t-[#204071]": !props.hideBorder,
					[props.headerIconClass]: props.headerIconClass,
				}
			)}
		></div>
	`;

	const headerTemplate = () => html`
		<div
			class=${classNames("select-none flex justify-between text-left items-center cursor-pointer", {
				[props.headerClass]: props.headerClass,
			})}
			@click=${props.onClick}
		>
			<div class="w-full common-transition">
				${typeof props.headerTitle === "string" ? unsafeHTML(props.headerTitle) : props.headerTitle}
			</div>
			${accordionTriangleIconTemplate()}
		</div>
	`;

	const contentTemplate = () => html`
		<div
			class=${classNames("grid transition-all duration-300 ease-in-out overflow-hidden", {
				"grid-rows-[1fr]": props.isOpen,
				"grid-rows-[0fr]": !props.isOpen,
			})}
		>
			<div class=${classNames("overflow-hidden transition-all duration-300", { "pt-4": props.isOpen })}>
				${props.contentTemplate()}
			</div>
		</div>
	`;

	return html` <div>${headerTemplate()} ${contentTemplate()}</div> `;
};
